import storage from 'redux-persist/lib/storage';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { setupListeners } from '@reduxjs/toolkit/query';
import * as Sentry from '@sentry/react';

import { codegenApi } from '@/api';

import { organisationReducer, organisationReducerName } from './organisation';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [organisationReducerName],
};

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  attachReduxState: false,
  stateTransformer: () => null,
  actionTransformer: (action) => {
    const requestId = action?.meta?.requestId;
    return requestId ? { type: action.type, meta: { requestId } } : { type: action.type };
  },
});

const rootReducer = combineReducers({
  [codegenApi.reducerPath]: codegenApi.reducer,
  [organisationReducerName]: organisationReducer,
});

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(codegenApi.middleware),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
});

const persistor = persistStore(store);

setupListeners(store.dispatch);

export { persistor, rootReducer, store };
